import React, { ReactNode } from "react";

interface ScheduleHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export const ScheduleHeader: React.FC<ScheduleHeaderProps> = ({
  title,
  subtitle,
  actions,
}) => (
  <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between mb-6">
    <div>
      <h1 className="text-2xl md:text-3xl font-bold tracking-tight mb-1">
        {title}
      </h1>
      {subtitle && (
        <p className="text-muted-foreground text-base md:text-lg">
          {subtitle}
        </p>
      )}
    </div>
    {actions && (
      <div className="mt-2 md:mt-0 flex-shrink-0">{actions}</div>
    )}
  </div>
);
